import { render, staticRenderFns } from "./ListBasePlan.vue?vue&type=template&id=39163e10&"
import script from "./ListBasePlan.vue?vue&type=script&lang=js&"
export * from "./ListBasePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports